
export class ScheduleRequest {
	scheduleId: number = 0;
	locCode: string = '';
	periodStartDate: string = '';
}